const fr = {
  "nav.chefs": "Nos Chefs",
  "nav.experiences": "Expériences",
  "nav.privateDining": "Dîner Privé",
  "nav.journal": "Journal",
  "nav.howItWorks": "Comment ça marche",
  "nav.events": "Événements",
  "nav.corporate": "Entreprises",
  "nav.bespoke": "Sur Mesure",
  "nav.giftCards": "Cartes Cadeaux",
  "nav.becomeChef": "Devenir Chef",
  "nav.about": "À Propos",
  "nav.contact": "Contact",
  "nav.faq": "FAQ",
  "nav.login": "Connexion",
  "nav.logout": "Déconnexion",
  "nav.account": "Mon Compte",
  "nav.findChef": "Trouver Mon Chef",
  "nav.more": "Plus",

  "hero.line1": "Une Cuisine d'Exception.",
  "hero.line2": "Chez Vous.",
  "hero.sub": "Des chefs privés vérifiés composent des expériences gastronomiques cinq étoiles dans l'intimité de votre salle à manger. À Paris et au-delà.",
  "hero.badge": "Conciergerie de Chefs Privés",
  "search.location": "Ville",
  "search.date": "Date",
  "search.guests": "Convives",
  "search.cuisine": "Cuisine",
  "search.experience": "Expérience",
  "search.any": "Toutes",
  "search.cta": "Trouver Mon Chef",

  "home.featuredEyebrow": "La Sélection de la Maison",
  "home.featuredTitle": "Des Chefs d'Exception",
  "home.viewAll": "Découvrir tous les chefs",
  "home.expEyebrow": "Expériences Signature",
  "home.expTitle": "Six Façons de Dîner Autrement",
  "home.trustEyebrow": "Notre Promesse",
  "home.trustTitle": "Chaque Chef, Rigoureusement Sélectionné",
  "home.trustIntro": "Derrière chaque badge « Chef Vérifié » se trouve une vérification professionnelle rigoureuse. Seuls les chefs ayant complété notre processus figurent sur la place de marché — votre table est toujours entre les mains d'un expert.",
  "trust.i1": "Vérification d'identité (KYC)",
  "trust.i2": "Examen de l'expérience professionnelle",
  "trust.i3": "Revue du profil et du portfolio",
  "trust.i4": "Revue des pratiques en cuisine",
  "trust.i5": "Portfolio de plats & standards de dégustation",
  "trust.i6": "Documentation d'hygiène applicable",
  "trust.i7": "Conformité bancaire",
  "home.manifestoEyebrow": "Le Manifeste",
  "man.c1t": "La Table Est Sacrée",
  "man.c1b": "Un dîner à la maison n'est pas une livraison. C'est du théâtre, de l'hospitalité et du savoir-faire — composé pour ceux que vous aimez, là où vous aimez être.",
  "man.c2t": "L'Artisanat Avant Tout",
  "man.c2b": "Nos chefs font le marché au matin, cuisinent chez vous et servent plat après plat. Rien de réchauffé, rien de pressé, rien d'ordinaire.",
  "man.c3t": "La Confiance, Vérifiée",
  "man.c3b": "Chaque chef de Chef à Domicile passe une vérification professionnelle avant de servir la moindre assiette. L'excellence est la condition d'entrée.",
  "home.marquee": "Chef à Domicile Paris — Dîner Privé de Luxe — Menus Sur Mesure — Table d'Exception — Hospitalité Cinq Étoiles —",
  "home.ctaTitle": "Votre table mérite un chef.",
  "home.ctaBtn": "Réserver une Expérience",
  "home.journalEyebrow": "Le Journal",
  "home.journalTitle": "Histoires de Table",

  "common.verified": "Chef Vérifié",
  "common.perGuest": "par convive",
  "common.from": "Dès",
  "common.viewProfile": "Voir le Profil",
  "common.book": "Réserver",
  "common.loading": "Chargement…",
  "common.error": "Une erreur est survenue.",
  "common.retry": "Réessayer",
  "common.empty": "Rien ici pour le moment.",
  "common.readMore": "Lire la suite",
  "common.back": "Retour",
  "common.send": "Envoyer",
  "common.sending": "Envoi…",
  "common.yearsExp": "{n} ans d'expérience",
  "common.reviews": "avis",
  "common.languages": "Langues",
  "common.all": "Toutes",
  "common.cancel": "Annuler",
  "common.save": "Enregistrer",
  "common.delete": "Supprimer",
  "common.add": "Ajouter",
  "common.optional": "optionnel",
  "common.next": "Continuer",
  "common.confirm": "Confirmer",
  "common.total": "Total",
  "common.guests": "convives",

  "chefs.title": "La Place de Marché des Chefs Vérifiés",
  "chefs.sub": "Des chefs privés d'exception, vérifiés par nos équipes, prêts à cuisiner chez vous.",
  "chefs.filters": "Filtres",
  "chefs.clear": "Effacer les filtres",
  "chefs.cuisine": "Cuisine",
  "chefs.city": "Ville",
  "chefs.minRating": "Note minimale",
  "chefs.maxPrice": "Prix max / convive",
  "chefs.language": "Langue du chef",
  "chefs.noResults": "Aucun chef ne correspond à ces critères. Élargissez votre recherche.",
  "chefs.count": "{n} chef(s) vérifié(s)",

  "chef.about": "À Propos du Chef",
  "chef.signature": "Plats Signature",
  "chef.reviews": "Avis des Convives",
  "chef.bookThis": "Réserver ce Chef",
  "chef.qualification": "Qualification",
  "chef.allergens": "Allergènes",
  "chef.dietary": "Régimes",
  "chef.prep": "{n} min de préparation",

  "exp.title": "Expériences Signature",
  "exp.sub": "Six façons choisies d'inviter la haute cuisine chez vous — du dîner à la carte intime à l'événement gastronomique entièrement sur mesure.",

  "booking.title": "Réservez Votre Expérience",
  "booking.step1": "Menu",
  "booking.step2": "Détails",
  "booking.step3": "Confirmer & Payer",
  "booking.selectDish": "Choisissez un plat signature",
  "booking.date": "Date",
  "booking.time": "Heure",
  "booking.address": "Adresse",
  "booking.city": "Ville",
  "booking.occasion": "Occasion",
  "booking.requests": "Demandes particulières",
  "booking.create": "Vérifier ma réservation",
  "booking.promo": "Code promo ou carte cadeau",
  "booking.promoApply": "Appliquer",
  "booking.promoApplied": "Code appliqué",
  "booking.chef": "Votre Chef",
  "booking.pricePerGuest": "Prix par convive",
  "booking.pay": "Procéder au Paiement Sécurisé",
  "booking.payNote": "Vous serez redirigé vers un paiement sécurisé Stripe. Le montant final est calculé par notre service de conciergerie.",
  "booking.loginFirst": "Veuillez vous connecter pour finaliser votre réservation.",
  "booking.stripeOff": "Le paiement en ligne est temporairement indisponible. Votre réservation est enregistrée — notre conciergerie vous contactera pour finaliser le paiement.",
  "booking.discount": "Remise",

  "pay.checking": "Confirmation de votre paiement…",
  "pay.success": "Paiement confirmé. Votre chef a été prévenu — rendez-vous à table.",
  "pay.failed": "Le paiement n'a pas abouti.",
  "pay.pending": "Le paiement est en cours de traitement. Cette page se mettra à jour automatiquement.",
  "pay.backAccount": "Voir mes réservations",

  "auth.loginTitle": "Bon Retour",
  "auth.registerTitle": "Créez Votre Compte",
  "auth.email": "Email",
  "auth.password": "Mot de passe",
  "auth.name": "Nom complet",
  "auth.loginBtn": "Se Connecter",
  "auth.registerBtn": "Créer un Compte",
  "auth.toRegister": "Nouveau chez Chef à Domicile ? Créer un compte",
  "auth.toLogin": "Déjà membre ? Se connecter",

  "account.title": "Mon Compte",
  "account.bookings": "Réservations",
  "account.favorites": "Favoris",
  "account.giftcards": "Cartes Cadeaux",
  "account.dietary": "Profil Alimentaire",
  "account.addresses": "Adresses",
  "account.noBookings": "Aucune réservation. Votre prochain dîner d'exception vous attend.",
  "account.noFavorites": "Aucun chef favori pour le moment.",
  "account.status": "Statut",
  "account.cancelBooking": "Annuler la réservation",
  "account.review": "Laisser un avis",
  "account.reviewComment": "Votre commentaire",
  "account.messages": "Messages",
  "account.writeMsg": "Écrire un message à votre chef…",
  "account.allergies": "Allergies",
  "account.diets": "Régimes & préférences",
  "account.saveProfile": "Enregistrer le profil",
  "account.addAddress": "Ajouter une adresse",
  "account.label": "Libellé (Maison, Bureau…)",
  "account.noGiftcards": "Aucune commande de carte cadeau.",
  "account.commaHint": "Séparez par des virgules",

  "gift.title": "Offrir une Table Inoubliable",
  "gift.sub": "Offrez une expérience de chef privé. Le destinataire reçoit une élégante carte cadeau, utilisable sur toute réservation.",
  "gift.amount": "Montant (25 € – 1000 €)",
  "gift.recipientName": "Nom du destinataire",
  "gift.recipientEmail": "Email du destinataire",
  "gift.message": "Message personnel",
  "gift.buy": "Acheter la Carte Cadeau",
  "gift.note": "Le code de la carte cadeau est généré et envoyé par email uniquement après confirmation du paiement.",

  "becomeChef.title": "Cuisinez pour les Plus Belles Tables",
  "becomeChef.sub": "Rejoignez Chef à Domicile comme chef privé. Vos menus, vos prix, votre agenda — nous vous apportons une clientèle exigeante.",
  "becomeChef.cta": "Postuler comme Chef",
  "becomeChef.bio": "Votre parcours culinaire",
  "becomeChef.years": "Années d'expérience",
  "becomeChef.qualification": "Qualification / formation",
  "becomeChef.city": "Ville",
  "becomeChef.cuisines": "Vos cuisines",
  "becomeChef.success": "Candidature reçue. Votre profil entre dans notre processus de vérification professionnelle — notre équipe vous contactera.",
  "becomeChef.s1t": "Postulez",
  "becomeChef.s1b": "Présentez votre expérience, votre formation et votre cuisine signature.",
  "becomeChef.s2t": "Soyez Vérifié",
  "becomeChef.s2b": "Identité, expérience, pratiques en cuisine et portfolio sont examinés professionnellement.",
  "becomeChef.s3t": "Cuisinez & Gagnez",
  "becomeChef.s3b": "Recevez des réservations d'une clientèle raffinée et soyez payé en toute sécurité.",

  "inquiry.contactTitle": "Contacter la Maison",
  "inquiry.contactSub": "Une question, un projet, une demande particulière — notre conciergerie répond sous 24 heures.",
  "inquiry.corporateTitle": "Expériences Entreprises",
  "inquiry.corporateSub": "Dîners de direction, réceptions clients, célébrations d'équipe — une cuisine à l'image de votre maison.",
  "inquiry.corporateCta": "Demander une Expérience Entreprise",
  "inquiry.eventsTitle": "Des Événements à Toute Échelle",
  "inquiry.eventsSub": "Anniversaires, mariages, réceptions — une production culinaire complète, du menu au service.",
  "inquiry.eventsCta": "Organiser Mon Événement",
  "inquiry.bespokeTitle": "Des Menus Entièrement Sur Mesure",
  "inquiry.bespokeSub": "Un menu unique, conçu avec votre chef autour de votre histoire, vos produits, votre occasion.",
  "inquiry.bespokeCta": "Lancer un Projet Sur Mesure",
  "inquiry.eventType": "Type d'événement",
  "inquiry.budget": "Budget",
  "inquiry.location": "Lieu",
  "inquiry.company": "Société",
  "inquiry.phone": "Téléphone",
  "inquiry.date": "Date souhaitée",
  "inquiry.guests": "Convives",
  "inquiry.message": "Votre message",
  "inquiry.success": "Merci. Notre équipe de conciergerie vous recontacte très vite.",

  "how.title": "Comment Ça Marche",
  "how.sub": "Du premier clic au dernier plat — sans effort, en quatre mouvements.",
  "how.s1t": "01 — Composez",
  "how.s1b": "Choisissez votre ville, la date, les convives et la cuisine. Parcourez les chefs vérifiés et leurs plats signature.",
  "how.s2t": "02 — Réservez",
  "how.s2b": "Réservez en quelques minutes. Le prix est calculé en toute transparence par convive — sans frais cachés.",
  "how.s3t": "03 — Accueillez Votre Chef",
  "how.s3b": "Votre chef arrive avec des produits frais, cuisine chez vous et sert plat après plat.",
  "how.s4t": "04 — Profitez, Simplement",
  "how.s4b": "Votre chef laisse la cuisine impeccable. Vous gardez les souvenirs — et les compliments.",

  "about.title": "La Maison",
  "about.p1": "Chef à Domicile est né d'une conviction simple : le plus beau restaurant du monde, c'est chez vous. Nous relions des hôtes exigeants à des chefs privés vérifiés qui transforment une salle à manger en table cinq étoiles.",
  "about.p2": "De Paris et au-delà, notre place de marché de conciergerie sélectionne des chefs sur 28 cuisines du monde — chacun vérifié professionnellement : identité, expérience, pratiques en cuisine et portfolio, avant même de nouer un tablier pour vous.",
  "about.p3": "Nous ne sommes pas de la livraison de repas. Nous sommes l'hospitalité — l'art de la table, ramené à la maison.",

  "privateDining.title": "Le Dîner Privé, Perfectionné",
  "privateDining.sub": "Des dîners intimes de 2 à 20 convives, orchestrés par un chef privé vérifié.",
  "privateDining.p1": "Une soirée avec Chef à Domicile commence bien avant le premier plat. Votre chef conçoit le menu avec vous, sélectionne les meilleurs produits du matin et arrive prêt à transformer votre cuisine en passe de grande maison.",
  "privateDining.p2": "Les plats se succèdent à votre table — pendant que vous restez avec vos invités. En fin de soirée, la cuisine est rendue impeccable.",
  "privateDining.cta": "Trouver un Chef pour Mon Dîner",

  "faq.title": "Questions Fréquentes",
  "faq.q1": "Comment les chefs sont-ils vérifiés ?",
  "faq.a1": "Chaque chef passe une vérification professionnelle : identité (KYC), expérience professionnelle, revue du profil, revue des pratiques en cuisine, portfolio de plats, documentation d'hygiène applicable et conformité bancaire. Seuls les chefs vérifiés apparaissent sur la place de marché.",
  "faq.q2": "Que comprend le prix par convive ?",
  "faq.a2": "Les courses du chef, la préparation, la cuisine, le service à table du menu et le nettoyage de la cuisine. Le total est calculé en toute transparence par notre service au moment de la réservation.",
  "faq.q3": "Les menus s'adaptent-ils aux allergies ou régimes ?",
  "faq.a3": "Oui. Enregistrez vos allergies et préférences dans votre profil alimentaire et ajoutez des demandes particulières à toute réservation — votre chef adapte le menu.",
  "faq.q4": "Comment fonctionne le paiement ?",
  "faq.a4": "Les paiements sont traités de façon sécurisée par Stripe. Vous n'êtes débité qu'à la confirmation de la réservation ; cartes cadeaux et codes promo s'appliquent avant le paiement.",
  "faq.q5": "Puis-je annuler une réservation ?",
  "faq.a5": "Oui, depuis votre compte. Consultez notre politique d'annulation pour les conditions selon le délai de prévenance.",

  "journal.title": "Le Journal",
  "journal.sub": "Gastronomie, art de recevoir et art de la table — par Chef à Domicile.",
  "journal.empty": "De nouvelles histoires s'écrivent. Revenez bientôt.",
  "journal.related": "Histoires Liées",

  "legal.termsTitle": "Conditions Générales",
  "legal.privacyTitle": "Politique de Confidentialité",
  "legal.cancelTitle": "Politique d'Annulation",
  "legal.terms1": "Chef à Domicile exploite une place de marché reliant des clients à des chefs privés indépendants et vérifiés. En utilisant chef-adomicile.com, vous acceptez ces conditions. La réservation forme un contrat entre le client et le chef, facilité par Chef à Domicile.",
  "legal.terms2": "Les prix sont affichés par convive ; le total final est calculé par notre service à la réservation. Le paiement est traité par notre partenaire de paiement sécurisé. Les chefs sont des professionnels indépendants, responsables de la prestation culinaire délivrée.",
  "legal.terms3": "L'ensemble des contenus, marques et visuels de ce site appartient à Chef à Domicile. Tout usage abusif de la plateforme, réservation frauduleuse ou comportement inapproprié peut entraîner la suspension du compte.",
  "legal.privacy1": "Nous collectons uniquement les données nécessaires à votre compte et vos réservations : identité, coordonnées, adresses, préférences alimentaires et historique. Nous ne vendons jamais vos données.",
  "legal.privacy2": "Les données de paiement sont traitées exclusivement par notre partenaire de paiement ; Chef à Domicile ne stocke jamais de numéros de carte. Les chefs ne reçoivent que les informations nécessaires à votre expérience.",
  "legal.privacy3": "Vous pouvez demander l'accès, la rectification ou la suppression de vos données personnelles à tout moment via la page contact.",
  "legal.cancel1": "Vous pouvez annuler une réservation depuis votre compte. Les annulations effectuées avec un préavis suffisant sont remboursées selon les conditions communiquées à la réservation.",
  "legal.cancel2": "Les annulations tardives peuvent entraîner des frais, le chef ayant acheté les produits et réservé la date. Les paiements par carte cadeau sont recrédités sur la carte.",
  "legal.cancel3": "Si un chef doit annuler, notre conciergerie vous propose un chef vérifié équivalent ou un remboursement intégral, à votre choix.",

  "footer.tag": "Une Cuisine d'Exception. Chez Vous.",
  "footer.explore": "Explorer",
  "footer.company": "La Maison",
  "footer.legal": "Légal",
  "footer.rights": "© 2026 Chef à Domicile — Tous droits réservés / All rights reserved",

  "seo.homeTitle": "Chef à Domicile — Chef Privé à Domicile | Dîner Privé de Luxe",
  "seo.homeDesc": "Réservez un chef privé vérifié pour un dîner d'exception à domicile. Dîner privé de luxe à Paris et au-delà — menus sur mesure, événements, expériences entreprises.",
};
export default fr;
